const NoteIcon = ({ stroke = '#A0A0AB' }: { stroke?: string }) => (
  <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.6001 1.5V3.75"
      stroke={stroke}
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.6001 1.5V3.75"
      stroke={stroke}
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.8501 9.75H11.8501"
      stroke={stroke}
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.8501 12.75H9.6001"
      stroke={stroke}
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.6001 2.625C15.0976 2.76 16.3501 3.7125 16.3501 7.2375V11.8725C16.3501 14.9625 15.6001 16.5075 11.8501 16.5075H7.3501C3.6001 16.5075 2.8501 14.9625 2.8501 11.8725V7.2375C2.8501 3.7125 4.1026 2.7675 6.6001 2.625H12.6001Z"
      stroke={stroke}
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default NoteIcon;
